import { Modal, Button, Input, notification, Form } from 'antd';
import React, { useState } from 'react';
import { useAppDispatch, useAuth } from '../../store/hooks';
import { Company, updateCompany } from '../../store/companySlice';
import { CompanyStatus } from '../../types/admin';

interface DeleteCompanyModalProps {
    open: boolean;
    handleClose: () => void;
    selectedCompany?: Company;
}

const DeleteCompanyModal: React.FC<DeleteCompanyModalProps> = ({ open, handleClose, selectedCompany }) => {

    const auth = useAuth()
    const dispatch = useAppDispatch()
    const [form] = Form.useForm<{ name: string }>()
    const [loading, setLoading] = useState<boolean>(false)


    const onFinishForm = async (values: { name: string }) => {
        setLoading(true)
        try {
            if (!auth) throw new Error("No auth for creating Company");
            if (!selectedCompany) throw new Error("No selected company to delete");

            await dispatch(updateCompany({
                id: selectedCompany.id,
                status: CompanyStatus.DELETE,
            }))

            notification.success({
                message: 'Company Deletion Started',
                description: 'The Company deletion has been started successfully.',
                duration: 3
            })
            form.resetFields()
            handleClose()
        } catch (error) {
            console.error("Error deleting the company", error)
            notification.error({
                message: 'Error Deleting Company',
                description: 'There was an error deleting the company. If the error persists, please contact support.',
                duration: 3,
            });
        } finally {
            setLoading(false)

        }
    }

    const handleCancel = () => {
        form.resetFields()
        handleClose()
    }


    return (
        <Modal
            open={open}
            title={`Delete Company: ${selectedCompany?.name}`}
            width={"70vw"}
            onCancel={handleCancel}
            footer={[
                <Button key="cancel" onClick={handleCancel}>
                    Cancel
                </Button>,
                <Button
                    key="delete"
                    variant='solid'
                    color='danger'
                    onClick={() => form.submit()}
                    loading={loading}
                    disabled={loading}
                >
                    Delete
                </Button>,
            ]}
        >
            <Form
                layout="vertical"
                onFinish={onFinishForm}
                form={form}
            >
                <Form.Item
                    label="Please type the name of the company to confirm deletion"
                    name="name"
                    rules={[
                        { required: true, message: 'Please enter the company name to confirm.' },
                        {
                            validator: (_, value) =>
                                value === selectedCompany?.name
                                    ? Promise.resolve()
                                    : Promise.reject(new Error('The name does not match the company.')),
                        },
                    ]}
                >
                    <Input autoFocus placeholder={selectedCompany?.name || 'Company name'} />
                </Form.Item>
            </Form>

        </Modal >
    );
};

export default DeleteCompanyModal;
